import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addGroupMembersRequest = {};
var _addGroupMembersResponse = { members: '_groupMember' };
var _groupMember = { joinedDate: 'google.protobuf.Timestamp' };
var _joinRequest = {};
var _joinResponse = { member: '_groupMember' };
var _leaveRequest = {};
var _leaveResponse = {};
var _listGroupMembersRequest = {};
var _listGroupMembersResponse = { members: '_groupMember' };
var _listMembershipsRequest = {};
var _listMembershipsResponse = {};
var _queryGroupMembersRequest = {};
var _queryGroupMembersResponse = { members: '_groupMember' };
var _queryMembershipsRequest = {};
var _queryMembershipsResponse = {};
var _queryMyMembershipRequest = {};
var _queryMyMembershipResponse = {};
var _queryNonGroupMembersRequest = {};
var _queryNonGroupMembersResponse = { members: '_groupMember' };
var _removeGroupMembersRequest = {};
var _removeGroupMembersResponse = {};
function resolveWixSocialGroupsApiV2GroupMembersServiceUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api_group-members-proxy',
                destPath: '',
            },
            {
                srcPath: '/_api/social-groups-proxy/members',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/group-members-proxy',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups-proxy/members',
                destPath: '',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/members',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/members',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/members',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/social-groups-proxy/members',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/members',
                destPath: '',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/members',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/members',
                destPath: '',
            },
            {
                srcPath: '/social-groups-proxy/api/members',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/members',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/social-groups-proxy/members',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Join a specific group.
 * Site owners can use it for groups with any privacy level and automatically receives `ADMIN` group role. A site member can use it only for public groups.
 * This endpoint doesn't support server signing.
 */
export function joinGroup(payload) {
    var _a = serializer(_joinRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_joinResponse, { _groupMember: _groupMember }).fromJSON;
    function __joinGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_member',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupMembersService.JoinGroup',
            url: resolveWixSocialGroupsApiV2GroupMembersServiceUrl({
                protoPath: '/v2/groups/{groupId}/join',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __joinGroup.fromReq = fromReq;
    __joinGroup.__isAmbassador = true;
    return __joinGroup;
}
/**
 * Leave a group.
 * This endpoint doesn't support server signing.
 */
export function leaveGroup(payload) {
    var _a = serializer(_leaveRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_leaveResponse, {}).fromJSON;
    function __leaveGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_member',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupMembersService.LeaveGroup',
            url: resolveWixSocialGroupsApiV2GroupMembersServiceUrl({
                protoPath: '/v2/groups/{groupId}/leave',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __leaveGroup.fromReq = fromReq;
    __leaveGroup.__isAmbassador = true;
    return __leaveGroup;
}
/**
 * Add site members to a specific group.
 *
 * For `SECRET` groups, group admins and group members can add additional members to their group.
 * For `PUBLIC` and `PRIVATE` groups, only group admins can add additional members to their group.
 * They can also allow all group members to add a new member to the group with `group.settings`.
 */
export function addGroupMembers(payload) {
    var _a = serializer(_addGroupMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addGroupMembersResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __addGroupMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_member',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupMembersService.AddGroupMembers',
            url: resolveWixSocialGroupsApiV2GroupMembersServiceUrl({
                protoPath: '/v2/groups/{groupId}/members',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addGroupMembers.fromReq = fromReq;
    __addGroupMembers.__isAmbassador = true;
    return __addGroupMembers;
}
/**
 * Removes site members from a specific group.
 *
 * Only group admins can remove members from their group.
 */
export function removeGroupMembers(payload) {
    var _a = serializer(_removeGroupMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeGroupMembersResponse, {}).fromJSON;
    function __removeGroupMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_member',
            method: 'DELETE',
            methodFqn: 'wix.social.groups.api.v2.GroupMembersService.RemoveGroupMembers',
            url: resolveWixSocialGroupsApiV2GroupMembersServiceUrl({
                protoPath: '/v2/groups/{groupId}/members',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeGroupMembers.fromReq = fromReq;
    __removeGroupMembers.__isAmbassador = true;
    return __removeGroupMembers;
}
/**
 * Retrieves a list of up to 100 group members, given the provided paging.
 *
 * For groups with `group.privacyStatus` set to `SECRET`, only group admins and group members can see the group and its content.
 *
 * Default sorts by `joinedDate` in descending order.
 */
export function listGroupMembers(payload) {
    var _a = serializer(_listGroupMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listGroupMembersResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __listGroupMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_member',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.GroupMembersService.ListGroupMembers',
            url: resolveWixSocialGroupsApiV2GroupMembersServiceUrl({
                protoPath: '/v2/groups/{groupId}/members',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listGroupMembers.fromReq = fromReq;
    __listGroupMembers.__isAmbassador = true;
    return __listGroupMembers;
}
/**
 * Retrieves a list of up to 100 group members, given the provided paging, sorting and filtering.
 * Groups managers can retrieve group members of any group.
 *
 * Supported fields for filtering:
 * - `role`
 *
 * Supported fields for sorting:
 * - `joinedOn`
 * - `role`
 */
export function queryGroupMembers(payload) {
    var _a = serializer(_queryGroupMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryGroupMembersResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __queryGroupMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_member',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupMembersService.QueryGroupMembers',
            url: resolveWixSocialGroupsApiV2GroupMembersServiceUrl({
                protoPath: '/v2/groups/{groupId}/members/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryGroupMembers.fromReq = fromReq;
    __queryGroupMembers.__isAmbassador = true;
    return __queryGroupMembers;
}
/**
 * Don't expose to 3rd parties! (Use GroupMembersWithProfilesService.QueryNonGroupMembersWithProfiles)
 * @deprecated
 */
export function queryNonGroupMembers(payload) {
    var _a = serializer(_queryNonGroupMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryNonGroupMembersResponse, {
        _groupMember: _groupMember,
    }).fromJSON;
    function __queryNonGroupMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_member',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupMembersService.QueryNonGroupMembers',
            url: resolveWixSocialGroupsApiV2GroupMembersServiceUrl({
                protoPath: '/v2/groups/{groupId}/members/non_group',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryNonGroupMembers.fromReq = fromReq;
    __queryNonGroupMembers.__isAmbassador = true;
    return __queryNonGroupMembers;
}
/**
 * Retrieves a list of group memberships of a site member.
 *
 * Only Wix users can retrieve a site member's group memberships.
 * Site members can only retrieve a list of their own group memberships.
 *
 * Default sorts by `groupId` in descending order.
 */
export function listMemberships(payload) {
    var _a = serializer(_listMembershipsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMembershipsResponse, {}).fromJSON;
    function __listMemberships(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_member',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.GroupMembersService.ListMemberships',
            url: resolveWixSocialGroupsApiV2GroupMembersServiceUrl({
                protoPath: '/v2/members/{memberId}/memberships',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMemberships.fromReq = fromReq;
    __listMemberships.__isAmbassador = true;
    return __listMemberships;
}
/**
 * Retrieves a list of up to 100 members and their membership status, given the provided paging and filtering.
 * Groups managers can see all memberships for any group.
 *
 * Supported fields for filtering:
 * - `role`
 * - `status`
 *
 * No supported fields for sorting.
 */
export function queryMemberships(payload) {
    var _a = serializer(_queryMembershipsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMembershipsResponse, {}).fromJSON;
    function __queryMemberships(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_member',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupMembersService.QueryMemberships',
            url: resolveWixSocialGroupsApiV2GroupMembersServiceUrl({
                protoPath: '/v2/members/{memberId}/memberships/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMemberships.fromReq = fromReq;
    __queryMemberships.__isAmbassador = true;
    return __queryMemberships;
}
export function queryMyMembership(payload) {
    var _a = serializer(_queryMyMembershipRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMyMembershipResponse, {}).fromJSON;
    function __queryMyMembership(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_member',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupMembersService.QueryMyMembership',
            url: resolveWixSocialGroupsApiV2GroupMembersServiceUrl({
                protoPath: '/v2/members/my/memberships/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMyMembership.fromReq = fromReq;
    __queryMyMembership.__isAmbassador = true;
    return __queryMyMembership;
}
//# sourceMappingURL=http.impl.js.map